import classNames from 'classnames';
import { IconV1 } from 'common/icon/iconV1.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { CellRenderType, ComponentTester } from './renderCell.js';

export const RenderStatusRating: ComponentTester<CellRenderType.statusRating> = ({ data, classes }) => {
  if (data?.icon) {
    if (data?.iconOnLeft) {
      return (
        <div className="u-flex u-flexAlignItemsCenter u-flexJustifyCenter">
          <IconV1 icon={data.icon} size={32} />
          <span className={classNames('u-block u-text-sm u-textSemibold u-span-width', data.status, classes)}>
            {data.text}
          </span>
        </div>
      );
    }
    return (
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyCenter">
        <span className={classNames('u-block u-text-sm u-textSemibold u-span-width-after', data.status, classes)}>
          {data.text}
        </span>
        <IconV1 icon={data.icon} size={32} />
      </div>
    );
  }
  if (data?.text) {
    return <span className={classNames('u-block u-text-sm u-textSemibold', data?.status, classes)}>{data.text}</span>;
  }
  messageLog.warning('No cell render props');
  return <div style={{ minWidth: '80px' }} />;
};
